export default __webpack_public_path__ + "static/media/referral_hero.a5fe8bd6.webp";